import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/matchdayCard.css';
// helpers
import {getText} from '../../../../../helpers/localization';
import {NMB, VPP_MATCHDAY_GREEK_CHANNEL} from '../../../../../constants/identifiers';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedMatchdaySubEventIndex: state.vpp.selectedMatchdaySubEventIndex,
        selectedGameIndex: state.vpp.selectedGameIndex,
        systemLanguage: state.vpp.systemLanguage
    };
};

class SelectedMatchdayEventCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.vpp.games,
                selectedMatchdaySubEventIndex: storeData.vpp.selectedMatchdaySubEventIndex,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        let event = this.props.event;
        let eventLiveStyle = style.eventLiveText;

        let message;
        if (this.state.games[this.state.selectedGameIndex].controllerState !== undefined
            && this.state.games[this.state.selectedGameIndex].controllerState[1] !== undefined
            && this.state.games[this.state.selectedGameIndex].controllerState[1] === NMB) {
            message = "0-0";
            eventLiveStyle = style.scoreText;
        } else {
            message = getText('LIVE', this.props.store);
        }


        return (
            <div id={'matchday_card'}>
                <div
                    className={event.channel === VPP_MATCHDAY_GREEK_CHANNEL ? style.bothTeamNameGreek : style.bothTeamName}>
                    {getText('Matchday_' + event.teamOne, this.props.store).concat('-').concat(getText('Matchday_' + event.teamTwo, this.props.store))}
                </div>
                <div className={eventLiveStyle}>
                    {message}
                </div>

            </div>


        );
    }
}

export default connect(mapStateToProps)(SelectedMatchdayEventCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/containers/selectedMatchdayEventCard.js